export const TOGGLE_LOADING = "TOGGLE_LOADING";

export const CLEAR_AUTH_STATE = "CLEAR_AUTH_STATE";

export const USER_MUST_LOGIN = "USER_MUST_LOGIN";

export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAIL = "GET_CURRENT_USER_FAIL";

export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";

export const LOGIN_USER_BY_KEY = "LOGIN_USER_BY_KEY";
export const LOGIN_USER_BY_KEY_SUCCESS = "LOGIN_USER_BY_KEY_SUCCESS";
export const LOGIN_USER_BY_KEY_FAIL = "LOGIN_USER_BY_KEY_FAIL";

export const CHECK_USERNAME_EXIST = "CHECK_USERNAME_EXIST";
export const CHECK_USERNAME_EXIST_SUCCESS = "CHECK_USERNAME_EXIST_SUCCESS";
export const CHECK_USERNAME_EXIST_FAIL = "CHECK_USERNAME_EXIST_FAIL";

export const GET_HELPICAL_TOKEN = "GET_HELPICAL_TOKEN";
export const GET_HELPICAL_TOKEN_SUCCESS = "GET_HELPICAL_TOKEN_SUCCESS";
export const GET_HELPICAL_TOKEN_FAIL = "GET_HELPICAL_TOKEN_FAIL";